var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Page',[_c('SiteMasthead',{attrs:{"mini":"true","title":"Testimonials"}}),_c('ContentRow',[_c('ContentContainer',[_c('TestimonialCards',{attrs:{"filter":_vm.filter},on:{"got_testimonials":_vm.handleGotTestimonials}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }